import React, { type ReactNode } from 'react';

import { abortSkjema } from 'src/store/actions/actionCreators';
import { useAppDispatch } from 'src/store/reducers';

import PendingChanges from '@helsenorge/core-framework/pending-changes';
import { resetPendingChanges } from '@helsenorge/core-framework/pending-changes/pending-changes-state';

interface PageRootWrapperProps {
  children: ReactNode;
}

const PageRootWrapper: React.FC<PageRootWrapperProps> = ({ children }): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const keepChanges = (): void => {
    dispatch(resetPendingChanges());
  };
  const discardChanges = (): void => {
    dispatch(resetPendingChanges());
    dispatch(abortSkjema());
  };

  return (
    <>
      <PendingChanges discardChanges={discardChanges} keepChanges={keepChanges} />
      {children}
    </>
  );
};
export default PageRootWrapper;
